<template>
    <div>
      <ul >
        <li class="skeleton_warp" v-for="(item, index) in data" :key="index">
          <div class="first_li">
            <div class="av animation_box"></div>
            <p class="animation_box"></p>
          </div>
          <p class="item animation_box"></p>
          <p class="item animation_box"></p>
          <p class="item animation_box"></p>
          <p class="item animation_box"></p>
        </li>
        
      </ul>
    </div>
      
  </template>
  <script>
  export default {
    name: 'HelloWorld',
    props: {
      data: Number
    }
  }
  </script>
  <style lang="scss" scoped>
  @import "~@/assets/sass/global.scss";
  .skeleton_warp {
    width: 100%;
    height: 200px;
    background: $a-white;
    padding:15px; 
    box-sizing: border-box;
    border-bottom: 1px solid $a-white;
    .item{
      height: 7px;
      background: $a-grey-f3;
      margin-top: 15px;
     
    }
    .av{
      width: 40px;
      height: 40px;
      background: $a-grey-f3;
      display: inline-block;
      border-radius: 50%;
    }
    .first_li{
      height: 50px;
      display: flex;
      background: $a-white;
      align-items: center;
      
      >p{
        width: 70px;
        height: 5px;
        background: $a-grey-f3;
        margin-left:15px;
        margin-bottom:3px;
      }
      
    }
    .animation_box{
        animation: myfirst 1s infinite;
      }

    @keyframes myfirst {
    0% {
      background: $a-grey-f3;
    }

    50% {
      background: $a-grey-f4;
    }

    100% {
      background: $a-grey-f3;
    }
  }

  }
  </style>